import { render, staticRenderFns } from "./keywords-widget.component.vue?vue&type=template&id=d496b558&scoped=true"
import script from "./keywords-widget.component.vue?vue&type=script&lang=ts"
export * from "./keywords-widget.component.vue?vue&type=script&lang=ts"
import style0 from "./keywords-widget.component.vue?vue&type=style&index=0&id=d496b558&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d496b558",
  null
  
)

export default component.exports